import React from 'react';
import Highcharts from 'highcharts';
import { map, forEach } from 'lodash';
import ReactTooltip from 'react-tooltip';
import classnames from 'classnames';

// local dependencies
import { pieChartHighCharts as PieChartHighChartsView } from 'ui/views/widgets/pieChartHighCharts';

// import { ColorConfigInActive as InActiveColorLegend, ColorConfig as ActiveColorConfig } from 'config/piechart-configs/resolution-config';
import { pieChartPreloader  } from 'modules/pieChart/pieChart.view';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { addClass, removeClass } from 'utils/dom';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { PieChartHighCharts } from 'ui/containers/PieChartHighCharts';
 *
 * // render
 * <PieChartHighCharts propName='propValue'/>
 */
class _PieChartHighCharts extends React.Component {

	/**
	 * @param {object} props - props
	 */
	constructor( props ) {
		super( props );
		this.state = {
			legend: [],
			series: this.props.data,
			activeIndex: null
		};
	}

	highChartsRender() {

		Highcharts.chart(
			{
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type: 'pie',
					renderTo: `${this.props.chartId}`,
					backgroundColor: 'rgba(255, 255, 255, 0.0)',
					height: 277,
					width: 350
				},
				tooltip: {
					borderWidth: 0,
					borderRadius: 0,
					backgroundColor: '#f2f2f2',
					fontSize: '11px',
					formatter: function () {
						return `<span className='ui-pie-chart-high-charts__tooltip'><span className='ui-pie-chart-high-charts__tooltip__box'></span>${this.point.name}-${this.point.y}(${this.point.percentageValue})</span>`;
					},
					shadow: false
				},
				credits: {
					enabled: false,
				},
				legend: {
					layout: 'vertical',
					align: 'right',
					verticalAlign: 'middle',
					itemMarginTop: 10,
					itemMarginBottom: 10,
					symbolRadius: 0,
					useHTML: true,
					labelFormatter: function () {
						return `<div class='legends'> ${this.name} ${this.percentageValue}</div>`;
					},
				},
				title: false,
				plotOptions: {
					pie: {
						dataLabels: {
							format: '{point.y}',
						},
						allowPointSelect: true,
						cursor: 'pointer',
						showInLegend: false,
						point: {
							events: {
								legendItemClick: function ( e ) {
									e.preventDefault();
									this.select();
								},

								updateIndex: ( options, colorIndex ) => {

									forEach( options, ( _data ) => {
										if( _data.index === colorIndex ) {

											const el = document.getElementById( `${this.props.chartId}_${_data.index}` );
											if( el.classList.contains( 'ui-pie-chart-high-charts__legends__item--highlight' ) ) {
												removeClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
											} else {
												addClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
											}
										} else {
											const el = document.getElementById( `${this.props.chartId}_${_data.index}` );
											removeClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
										}
									} );
								},
								click: function ( e ) {
									e.preventDefault();
									this.events.updateIndex( this.series.data, e.point.colorIndex );
									this.select();
								},
							},
						},
					}
				},
				series: this.state.series
			},
			( chart ) => {
				const legendNew = [];
				const legendOverflow = [];

				map( chart.series[ 0 ].data, ( data, i ) => {

					const className = classnames( 'ui-pie-chart-high-charts__legends__item' );

					9 > i
						? legendNew.push(
								<div
									className={ className }
                                    onClick={() => {
										forEach( chart.series[ 0 ].data, ( _data ) => {
											if( _data.index === i ) {

												const el = document.getElementById( `${this.props.chartId}_${_data.index}` );
												if( el.classList.contains( 'ui-pie-chart-high-charts__legends__item--highlight' ) ) {
													removeClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
												} else {
													addClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
												}
											} else {
												const el = document.getElementById( `${this.props.chartId}_${_data.index}` );
												removeClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
											}
										} );
										data.select();
									} }
                                    key={ i } id={ `${this.props.chartId}_${i}` }
								>
									<div
										className="ui-pie-chart-high-charts__legends__item__symbol"
										style={{ background: `${data.color}` }}
									></div>
									<div className="ui-pie-chart-high-charts__legends__item__seriesName">
										{data.name}
									</div>
                                </div>
                            )
                        : null;
                    
                    9 < i
						? legendOverflow.push(
								<div
									className={ className }
                                    onClick={() => {
										
										forEach( chart.series[ 0 ].data, ( _data ) => {
											if( _data.index === i ) {

												const el = document.getElementById( `${this.props.chartId}_${_data.index}` );
												if( el.classList.contains( 'ui-pie-chart-high-charts__legends__item--highlight' ) ) {
													removeClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
												} else {
													addClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
												}
											} else {
												const el = document.getElementById( `${this.props.chartId}_${_data.index}` );
												removeClass( el, 'ui-pie-chart-high-charts__legends__item--highlight' );
											}
										} );
										data.select();
									} }
                                    key={ i } id={ `${this.props.chartId}_${i}` }
								>
									<div
										className="ui-pie-chart-high-charts__legends__item__symbol"
										style={{ background: `${data.color}` }}
									></div>
									<div className="ui-pie-chart-high-charts__legends__item__seriesName">
										{data.name}
									</div>
                                </div>
                            )
						: null;

					9 === i
						? legendNew.push(
								<div
									className={ className }
									data-tip="custom show"
                                    data-event="click focus"
                                    key='other'
								>
									<div
										className="ui-pie-chart-high-charts__legends__item__symbol"
										style={{ background: '#89bbe8' }}
									></div>
									<div className="ui-pie-chart-high-charts__legends__item__seriesName">
										Other
									</div>
                                </div>
                            )
						: null;
                } );
                
                legendNew.push(
                    <ReactTooltip
						globalEventOff="click"
						backgroundColor="#f2f2f2"
                        clickable={ true }
                        key={ 'tooltip' }
                    >
                        { legendOverflow }
                    </ReactTooltip>
                );

				this.setState( {
					legend: legendNew,
				} );
			}
		);

		
	}

	componentDidMount() {

		// Highcharts.setOptions( {
		// 	colors: InActiveColorLegend
		// } );

		this.highChartsRender();
	}

	/**
	 * @desc Render a React view component
	 */
	render() {
		return <PieChartHighChartsView {...this.state} chartId={ this.props.chartId } />;
	}
}

// set display name
_PieChartHighCharts.displayName = 'PieChartHighCharts';

// set default props
_PieChartHighCharts.defaultProps = {};

// prop types
_PieChartHighCharts.propTypes = {};

export const PieChartHighCharts = withNetworkState( pieChartPreloader, _PieChartHighCharts );
